// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables for Instec */\n[data-v-1a4bc85f]:export {\n  menuBg: #0F4C81;\n  menuText: #ffffff;\n  menuActiveText: #0F4C81;\n  menuActiveBg: #ffffff;\n}\n\n/* Mixins */\n.form-block[data-v-1a4bc85f] {\n  width: 90%;\n}\n@media (min-width: 1024px) {\n.form-block .el-form[data-v-1a4bc85f] {\n    width: 80%;\n}\n}\n.form-block .el-steps--simple[data-v-1a4bc85f] {\n  padding: 13px 2%;\n}\n.form-block .el-step__description[data-v-1a4bc85f] {\n  padding: 5%;\n}", ""]);
// Exports
module.exports = exports;
